import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ValidatorsProps, Response } from '@ui/src';
import {
  accountsCategoriesApi,
  CreateCategoryValidatorResponse,
} from '../services/categories';
import { Category } from '../../types';

export interface ChartsCategoriesState {
  isLoading: boolean;
  categories: Category[];
  categoryValidation?: ValidatorsProps;
  panelIsOpen: boolean;
  formValues?: {
    name: string;
    type: string;
    number: string;
  };
  selectedCategoryIsLoading?: boolean;
  selectedCategory?: Category;
}

const initialState: ChartsCategoriesState = {
  isLoading: false,
  categories: [],
  panelIsOpen: false,
};

export const chartCategoriesSlice = createSlice({
  name: 'chartCategories',
  initialState,
  reducers: {
    changePanelState: (state, action: PayloadAction<boolean>) => {
      state.panelIsOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        accountsCategoriesApi.endpoints.getCreateCategoryValidator
          .matchFulfilled,
        (state, action: PayloadAction<CreateCategoryValidatorResponse>) => {
          if (
            action.payload.data &&
            action.payload.data.createAccountCategorySchema
          ) {
            state.categoryValidation =
              action.payload.data.createAccountCategorySchema;
          }
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategories.matchPending,
        (state) => {
          state.isLoading = true;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategories.matchFulfilled,
        (state, action: PayloadAction<Response<Category>>) => {
          state.categories = action.payload.data.edges.map((item) => item.node);
          state.isLoading = false;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategories.matchRejected,
        (state) => {
          state.isLoading = false;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.createCategory.matchFulfilled,
        (state, action: PayloadAction<{ data: Category }>) => {
          const nextCategories = ([] as Category[]).concat(state.categories);

          nextCategories.push(action.payload.data);

          state.categories = nextCategories;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategory.matchPending,
        (state) => {
          state.selectedCategoryIsLoading = true;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategory.matchFulfilled,
        (state, action: PayloadAction<{ data: Category }>) => {
          state.selectedCategory = action.payload.data;
          state.selectedCategoryIsLoading = false;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.getAccountsCategory.matchRejected,
        (state) => {
          state.selectedCategoryIsLoading = false;
        },
      )
      .addMatcher(
        accountsCategoriesApi.endpoints.updateCategory.matchFulfilled,
        (state, action: PayloadAction<{ data: Category }>) => {
          const nextCategories = state.categories.map((item) => {
            let result = { ...item };

            if (item.id === action.payload.data.id) {
              result = action.payload.data;
            }

            return result;
          });

          state.categories = nextCategories;
        },
      );
  },
});

export const { changePanelState } = chartCategoriesSlice.actions;

export default chartCategoriesSlice.reducer;
